import { Box, Typography } from "@material-ui/core";
import { Grid, styled } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { EvOptions, imagesList, StateOptions } from "../../../constants";
import { primary } from "../../../constants/theme";
import { Context } from "../../../context/context";
import { MemoizedButton } from "../../../SDK/button";
import { MemoizedNameField } from "../../../SDK/input/nameInput";
import { MemoizedSelectDropDown } from "../../../SDK/selectDropdown/selectDropdown";
import { checkError } from "../../../SDK/utils/validationHelpers";
import { createCookieInHour, getCookie } from "../../../utils/cookie";
import { myScroll } from "../../../utils/myScroll";
import { MemoizedOTP } from "../../Otp/otp";
import useBookingForm from "../BookingForm/Hook/useBookingForm";

const CustomBookingForm = styled(Box)(({ theme }) => ({
  background: "#FEF8E6",
  margin: "16px 0px 0px 0px",
  marginTop: "80px",
  padding: "75px 100px ",
  ".otp-styles": {
    ".input-box": {
      maxWidth: "500px",
      width: "100%",
      //marginBottom: "24px",
    },
  },
  ".booking-form-head": {
    fontWeight: "900",
    fontSize: "54px",
    lineHeight: "102px",
    color: primary.dark,
  },

  ".refundable": {
    width: "25%",
  },
  ".coupon-applied": {
    fontWeight: "500",
    fontSize: "20px",
    lineHeight: "30px",
  },
  ".coupon-desctiption": {
    fontWeight: "400",
    fontSize: "20px",
    lineHeight: "30px",
    marginTop: "10px",
  },
  ".coupon-note": {
    fontWeight: "400",
    fontSize: "14.8037px",
    lineHeight: "22px",
    color: "#8C8C8C",
  },
  ".check-label": {
    width: "75%",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
    color: "#666666",
  },
  ".box-book-form": {
    maxWidth: "500px",
    width: "100%",
    //marginBottom: "24px",
  },
  ".form-booking": {
    marginTop: "50px",
  },
  ".terms-and-conditions": {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "18px",
    textAlign: "center",
    marginTop: "10px",
    maxWidth: "50%",
    color: primary.main,
    textDecoration: "underline",
    cursor: "pointer",
  },
  ".otp-disclaimer-text": {
    width: "75%",
    fontWeight: "700",
    fontSize: "14px",
    textAlign: "center",
    color: "#666666",
    marginRight: "0px !important",
  },
  [theme.breakpoints.down("md")]: {
    marginTop: "0px",
    padding: "16px",

    ".booking-form-head": {
      fontSize: "28px",
      lineHeight: "56px",
      textAlign: "center",
    },

    ".refundable": {
      width: "60%",
    },
    ".form-booking": {
      marginTop: "32px",
    },
    ".coupon-applied": {
      fontSize: "16px",
      lineHeight: "24px",
    },
    ".coupon-desctiption": {
      fontSize: "16px",
      lineHeight: "24px",
      marginTop: "10px",
    },
    ".coupon-note": {
      fontSize: "12px",
      lineHeight: "20px",
    },
    ".check-label": {
      fontSize: "13px",
      lineHeight: "20px",
      width: "85%",
    },
    ".terms-and-conditions": {
      fontSize: "10px",
      lineHeight: "15px",
      maxWidth: "100%",
    },
    ".otp-disclaimer-text": {
      marginTop: "0.8em",
      width: "100%",
      fontSize: "12px",
      linHeight: "16px",
    },
  },
}));

const LeadCaptureBookingForm = ({ vehicleData }) => {
  const [isChecked, setIsChecked] = useState(true);
  const state = useContext(Context);

  let cacheInfo = getCookie("user_verified")
    ? JSON.parse(getCookie("user_verified"))
    : undefined;

  // const { showOtpValidation } = useContext(Context);

  const { showSnackbar } = useContext(Context);

  const { form, loading, setVehicleDetails } = useBookingForm();

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  form.initialValues.state = state.selectedState;

  useEffect(() => {
    form.initialValues.vehicle = vehicleData?.name;
    setVehicleDetails(vehicleData);
  }, [form, setVehicleDetails, vehicleData]);

  return (
    <CustomBookingForm>
      <Box id="booking-form">
        <Typography variant="h2" className="booking-form-head">
          Book your vehicle{" "}
        </Typography>
        <Box>
          <LazyLoadImage
            className="refundable"
            src={imagesList.leadCaptureGuaranteed}
            alt="Refundable"
          />
        </Box>

        <Box className="form">
          <form onSubmit={form.handleSubmit} className="form-booking">
            <Grid container rowSpacing={2}>
              <Grid
                sx={{ display: "block" }}
                container
                item
                rowSpacing={2}
                xs={12}
                md={6}
              >
                <Grid item xs={12}>
                  <MemoizedNameField
                    sx={{ marginRight: { xs: "0px", md: "10px" } }}
                    className="input-box box-book-form"
                    name="name"
                    placeholder="Your Name"
                    value={form.values.name}
                    onChange={(e) => {
                      form.handleChange(e);
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <MemoizedOTP
                    checked={isChecked}
                    form={form}
                    input_type="webform"
                    className="otp-styles"
                    type="new_form"
                    connect_type=""
                  />
                </Grid>

                <Grid item xs={12}>
                  <MemoizedSelectDropDown
                    className="input-box box-book-form"
                    form={form}
                    id={"vehicle"}
                    name="vehicle"
                    required={true}
                    disabled={true}
                    title={"Select Vehicle"}
                    value={form.values.vehicle}
                    optionsData={EvOptions}
                    onChange={form.handleChange}
                  />
                </Grid>

                <Grid item xs={12}>
                  <MemoizedSelectDropDown
                    className="input-box box-book-form"
                    form={form}
                    id={"state"}
                    name="state"
                    required={true}
                    disabled={true}
                    title={"Select state"}
                    value={form.values.state}
                    optionsData={StateOptions}
                    onChange={form.handleChange}
                    error={!!checkError("state", form)}
                  />
                </Grid>
              </Grid>
              <Grid sx={{ display: "block" }} item xs={12} md={6}>
                <Typography className="coupon-applied">
                  Coupon applied
                </Typography>
                <Box
                  sx={{
                    background: `url(${imagesList.leadCaptureCouponAppliedBg}) 0% 0% / contain no-repeat`,
                    padding: "18px 16px 12px 88px",
                    marginTop: "15px",
                    fontSize: { xs: "14px", md: "16px" },
                  }}
                >
                  FESTIVE 5K DISCOUNT
                </Box>
                <Typography className="coupon-desctiption">
                  <b>Get upto Rs.5000</b> discount on your vehicle*
                </Typography>
                <Typography className="coupon-note">
                  *Applicable on booking of Rs.499
                </Typography>

                <Box>
                  {!state.showOtpModule ? (
                    <Box
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "baseline",
                      }}
                      sx={{ mt: { xs: "24px", md: "24px" } }}
                    >
                      <input
                        label="bookingForm-checkbox"
                        type="checkbox"
                        required={true}
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                      />

                      <Typography className="check-label">
                        I agree to the terms and conditions below and give my
                        consent to receive calls and messages to provide further
                        information, even if my number is registered on DND/NDNC.
                      </Typography>
                    </Box>
                  ) : (
                    <Box>
                      <Typography className="otp-disclaimer-text">
                        OTP Verification enables us to secure your account and
                        enrol you into our promotional programs
                      </Typography>
                    </Box>
                  )}
                </Box>
                <MemoizedButton
                  id="lead-form"
                  //type="submit"
                  disabled={!isChecked}
                  className={"schedule-test-drive-button"}
                  content={"Book test drive"}
                  sx={{ width: { xs: "100%", md: "50%" }, mt: "24px" }}
                  loading={loading}
                  handleClick={(e) => {
                    // showOtpValidation(true);
                    // form.handleSubmit(e);
                    createCookieInHour(
                      "lead_trigger",
                      "book_vehicle_lead_capture",
                      10
                    );
                    // if (
                    //   // (state.posthogValues === "otpVerificationVar" ||
                    //   //   state.posthogValues === "OtpVerificationFAQVar") &&
                    //   (cacheInfo?.verified === undefined ||
                    //     cacheInfo?.verified === false) &&
                    //   form?.values?.mobile?.toString()?.length === 10
                    // ) {
                    //   form.errors.mobile = "Verify your Mobile Number with OTP";
                    //   showSnackbar(
                    //     "Verify your Mobile Number with OTP",
                    //     "error"
                    //   );
                    //   form.handleChange(e);
                    // } else {
                    form.handleSubmit(e);
                    // }
                  }}
                />
                <Typography
                  className="terms-and-conditions"
                  onClick={() => {
                    myScroll(
                      0,
                      document.getElementById("footer").offsetTop - 100,
                      "smooth"
                    );
                    // window?.scrollTo &&
                    //   window?.scrollTo({
                    //     top: document.getElementById("footer").offsetTop - 100,
                    //     behavior: "smooth",
                    //   });
                  }}
                >
                  Terms and Conditions
                </Typography>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Box>
    </CustomBookingForm>
  );
};
// export default LeadCaptureBookingForm;

export const MemoizedLeadCaptureBookingForm = React.memo(
  LeadCaptureBookingForm
);
